/* eslint-disable no-loop-func */
import React, { Component } from 'react';
import html2canvas from 'html2canvas';
// import ReactDOM from 'react-dom'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import {
  init,
  getList,
  getFaseList,
  getFaseListNovo,
  create,
  enviarTemposControlador,
  lerQuantidadeAneis,
  lerTemposControlador,
  lerDadosFasesControlador,
  enviarHorarioVeraoControlador,
  getLocalCEP,
  getImageCroquiById,
} from './controladorActions';

import LabelAndInput from '../common/form/labelAndInput';
// import LabelAndSelectForm from '../common/form/labelAndSelectForm';
// import checkboxFase from '../common/form/checkboxFase';
import LabelAndSelectForm from '../common/form/labelAndSelectForm';
import Button from '../common/form/button';
import ControladorMonitoramentoToggle from './controladorMonitoramentoToggle';
// import checkboxFase from '../common/form/checkboxFase';
import ActionConfirmModal from '../common/components/actionConfirmModal';
import ProcessingOverlay from '../common/components/processingOverlay';
import { Modal } from 'react-bootstrap';
import { toastr } from 'react-redux-toastr';

// import SelectControlador from './selectControlador';
// import SelectSequenciaControlador from './selectSequenciaControlador';
import SelectFaseControlador from './selectFaseControlador';

import swal from 'sweetalert2';
import If from '../common/operator/if';
import ConexaoUDPTeste from './controladorConexao';

import { Marker } from 'react-google-maps';
import MapaControlador from './mapaControlador';
import SelectNumeroControlador from '../common/selectdb/selectNumeroControlador'; // foi desativado pq agora pode repetir o número do controlador
import ListFase from '../fase/faseList';
import PermissaoUsuario from '../auth/permissao';
import ButtonTooltip from '../common/form/buttonTooltip';
import ControladorReportModal from '../relatorio/controlador/ControladorReportModal';
import FaseConflitoControlador from './controladorFaseConflito';
import {
  consolidarConflitosAneisNoForm,
  syncConflitosAnelParaForm,
  syncConflitosFormParaAnel,
} from './controladorFaseConflitoUtils';
import { validaPermissaoReadOnly } from '../auth/permissaoActions';

const InputValidacao = require('../common/form/inputValidacao.js');
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

const CANCEL_IGNORE_ROOT_KEYS = new Set([
  'dataHoraAnterior',
  'dataHoraAtual',
  'versaoMCPControlador',
  'pluviometrico_ativo',
  'anel',
  'numero_fases',
  'numero_fases_fim',
  'tempo_vermelho_min',
  'tempo_amarelo_min',
  'tempo_verde_min',
  'fases',
  'croqui_file',
  'croqui_file_data',
  'croqui_file_name',
]);

const CANCEL_IGNORE_ANEL_KEYS = new Set(['imageLog']);

class ControladorForm extends Component {
  constructor(props) {
    super(props);

    this.componentRef = React.createRef();

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.clickOk = this.clickOk.bind(this);
    this.renderMarker = this.renderMarker.bind(this);
    // this.submitForm = this.submitForm.bind(this);

    this.enviarFaseTempoControlador = this.enviarFaseTempoControlador.bind(this);
    this.lerFaseTempoControlador = this.lerFaseTempoControlador.bind(this);
    this.enviarHorarioVeraoControlador = this.enviarHorarioVeraoControlador.bind(this);
    this.onBlurVerdeMinimo = this.onBlurVerdeMinimo.bind(this);
    this.geraGridFase = this.geraGridFase.bind(this);
    this.salvarControlador = this.salvarControlador.bind(this);
    this.cepOnBlur = this.cepOnBlur.bind(this);
    this.verificaAlteracao = this.verificaAlteracao.bind(this);
    this.fasesForamAlteradas = this.fasesForamAlteradas.bind(this);
    this.handleCancelar = this.handleCancelar.bind(this);
    this.confirmarCancelar = this.confirmarCancelar.bind(this);
    this.cancelarConfirmacaoCancelar = this.cancelarConfirmacaoCancelar.bind(this);
    this.executarSubmitControlador = this.executarSubmitControlador.bind(this);
    this.atualizarBaselineAposSincEquipamento = this.atualizarBaselineAposSincEquipamento.bind(this);
    this.anelChange = this.anelChange.bind(this);

    this.croquiHandleFileChange = this.croquiHandleFileChange.bind(this);
    this.deleteCroquiFile = this.deleteCroquiFile.bind(this);
    this.renderFileInput = this.renderFileInput.bind(this);

    this.state = {
      show: false,
      showModal: false,
      lat: 0,
      lng: 0,
      cepLat: props.latitude || 0,
      cepLng: props.longitude || 0,
      html: '',
      htmlMapaCont: '',
      fases: [],
      cep: props.cep || 0,
      OldValues: this.props.valores,
      OldFases: [],
      messageModal: '',
      carregouFase: false,
      showTab: 'tabAnel',
      showIdentTab: 'tabIdentDados',
      // Croqui File
      croquiFileSelected: null,
      croquiFileErrorMessage: '',
      showCroquiDeleteWarning: false,
      cepErro: '',
      dirtyFases: false,
      baselineValuesString: '',
      showReportModal: false,
      showCancelConfirm: false,
      processingTagline: 'Controlador',
      processingDetail: '',
      baselineReady: false,
      // anelSelect: this.props.valores.anel
    };

    this._baselineTimer = null;
  }

  componentDidMount() {
    if (this.props.registerCancelarAlteracao) {
      this.props.registerCancelarAlteracao(this.handleCancelar);
    }
  }

  componentWillUnmount() {
    if (this.props.registerCancelarAlteracao) {
      this.props.registerCancelarAlteracao(null);
    }
    if (this._baselineTimer) {
      clearTimeout(this._baselineTimer);
      this._baselineTimer = null;
    }
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.valores && prevProps.valores.id;
    const currId = this.props.valores && this.props.valores.id;

    if (prevId !== currId && currId) {
      this.setState({ baselineReady: false });

      if (this.props.controladorId && this.props.valores && this.props.valores.aneis) {
        this.props.valores.aneis.forEach(anel => {
          if (anel) {
            anel.fases = [];
          }
        });
      }

      const anelIndex = Math.max(0, (parseInt(this.props.valores.anel, 10) || 1) - 1);
      this.geraGridFase(anelIndex);
    }
  }

  isCampoConflitoEspelho(key) {
    return /^fase\d+_fase\d+$/.test(key);
  }

  normalizeCep(value) {
    if (value === undefined || value === null) return value;
    const digits = String(value).replace(/\D/g, '');
    if (digits === '') return '';
    return digits.padStart(8, '0');
  }

  normalizeValuesForComparison(obj) {
    if (!obj) return obj;

    // Converter campos numéricos conhecidos para string para comparação consistente
    const numericFields = new Set([
      'porta',
      'tempo_amarelo_min',
      'tempo_verde_min',
      'tempo_vermelho_min',
      'numero_fases',
      'numero_controlador',
      'grupo_fisico_id',
      'anel',
    ]);

    const walk = value => {
      if (Array.isArray(value)) {
        return value.map(walk);
      }

      if (value && typeof value === 'object') {
        const out = {};
        Object.keys(value).forEach(key => {
          const v = value[key];
          if (key === 'cep') {
            out[key] = this.normalizeCep(v);
            return;
          }
          if (numericFields.has(key) && v !== undefined && v !== null) {
            out[key] = String(v);
            return;
          }
          out[key] = walk(v);
        });
        return out;
      }

      return value;
    };

    return walk(obj);
  }

  stripAnelForCancelComparison(anel) {
    if (!anel || typeof anel !== 'object') return anel;

    const out = {};
    Object.keys(anel).forEach(key => {
      if (CANCEL_IGNORE_ANEL_KEYS.has(key)) return;

      if (key === 'fases' && Array.isArray(anel.fases)) {
        out.fases = anel.fases.map(fase => ({ ...fase }));
        return;
      }

      out[key] = anel[key];
    });

    return out;
  }

  stripForCancelComparison(obj) {
    if (!obj || typeof obj !== 'object') return obj;

    const out = {};
    Object.keys(obj).forEach(key => {
      if (CANCEL_IGNORE_ROOT_KEYS.has(key) || this.isCampoConflitoEspelho(key)) return;

      if (key === 'aneis' && Array.isArray(obj.aneis)) {
        out.aneis = obj.aneis.map(anel => this.stripAnelForCancelComparison(anel));
        return;
      }

      out[key] = obj[key];
    });

    return out;
  }

  buildSnapshotForCancelComparison(obj) {
    return this.normalizeValuesForComparison(this.stripForCancelComparison(obj));
  }

  agendarBaselineInicial() {
    if (this._baselineTimer) {
      clearTimeout(this._baselineTimer);
    }

    this._baselineTimer = setTimeout(() => {
      this._baselineTimer = null;
      if (!this.props.valores) return;
      this.captureBaselineFromProps();
    }, 120);
  }

  atualizarBaselineAposSincEquipamento() {
    if (this._baselineTimer) {
      clearTimeout(this._baselineTimer);
      this._baselineTimer = null;
    }
    this.captureBaselineFromProps();
  }

  captureBaselineFromProps() {
    try {
      const snapshot = this.buildSnapshotForCancelComparison(this.props.valores);
      this.setState({
        OldValues: snapshot,
        baselineValuesString: JSON.stringify(snapshot || {}),
        baselineReady: true,
      });
    } catch (_) {
      this.setState({ OldValues: this.props.valores });
      try {
        this.setState({
          baselineValuesString: JSON.stringify(this.props.valores || {}),
          baselineReady: true,
        });
      } catch (__) {
        this.setState({ baselineValuesString: '', baselineReady: true });
      }
    }
  }

  finalizarSaidaFormulario() {
    if (this._baselineTimer) {
      clearTimeout(this._baselineTimer);
      this._baselineTimer = null;
    }

    this.setState({
      fases: [],
      html: <div />,
      dirtyFases: false,
      OldFases: [],
      baselineReady: false,
      showCancelConfirm: false,
    });
    this.props.init();
  }

  fasesForamAlteradas() {
    if (!this.state.OldFases || this.state.OldFases.length === 0) return false;
    if (!this.state.fases) return false;

    try {
      return JSON.stringify(this.state.OldFases) !== JSON.stringify(this.state.fases);
    } catch (_) {
      return this.state.dirtyFases === true;
    }
  }

  handleCancelar() {
    if (!this.state.baselineReady) {
      this.finalizarSaidaFormulario();
      return;
    }

    let formChanged = false;
    try {
      const normalizedCurrent = this.buildSnapshotForCancelComparison(this.props.valores) || {};
      const normalizedBaseline = JSON.parse(this.state.baselineValuesString || '{}') || {};

      let comparableCurrent = normalizedCurrent;
      let comparableBaseline = normalizedBaseline;

      // Ao editar CEP, a tela pode recalcular latitude/longitude automaticamente no blur.
      // Se o CEP final voltou ao mesmo do baseline, ignorar diferenças de coords para não dar falso-positivo.
      if (
        comparableBaseline.cep !== undefined &&
        comparableCurrent.cep !== undefined &&
        comparableBaseline.cep === comparableCurrent.cep
      ) {
        comparableCurrent = { ...comparableCurrent };
        comparableBaseline = { ...comparableBaseline };
        delete comparableCurrent.latitude;
        delete comparableCurrent.longitude;
        delete comparableBaseline.latitude;
        delete comparableBaseline.longitude;
      }

      formChanged = JSON.stringify(comparableCurrent) !== JSON.stringify(comparableBaseline);
    } catch (_) {
      formChanged = false;
    }

    const fasesAlteradasResult = this.fasesForamAlteradas();
    const hasChanges = formChanged || fasesAlteradasResult;

    if (!hasChanges) {
      this.finalizarSaidaFormulario();
      return;
    }

    this.setState({ showCancelConfirm: true });
  }

  confirmarCancelar() {
    this.finalizarSaidaFormulario();
  }

  cancelarConfirmacaoCancelar() {
    this.setState({ showCancelConfirm: false });
  }

  executarSubmitControlador() {
    return new Promise((resolve, reject) => {
      const handler = this.props.handleSubmit(
        async values => {
          try {
            await this.props.onSubmit(values);
            resolve(values);
          } catch (error) {
            reject(error);
          }
        },
        errors => reject(errors),
      );

      handler();
    });
  }

  enviarHorarioVeraoControlador() {
    swal({
      title: 'Enviar as configurações de Horário de Verão para a "Central"?',
      html: '<h5>Essa ação vai substituir as configurações existentes na central.</h5>',
      type: 'question',
      showCancelButton: true,
      confirmButtonColor: 'primary',
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: 'false',
    }).then(result => {
      if (result.value) {
        this.setState({ showModal: true }); // da show no modal de aguarde

        const data = {
          ip: this.props.enderecoUDP.ip,
          porta: this.props.enderecoUDP.porta,
          data_inicio_verao: window.$('#data_inicio_verao').val(),
          data_fim_verao: window.$('#data_fim_verao').val(),
          numCont: this.props.valores.numero_controlador,
        };

        this.props
          .enviarHorarioVeraoControlador(data)
          .then(result => {
            this.setState({ showModal: false });

            if (result.error) {
              //se retornar true no erro, chama o metodo que pega do banco
              toastr.error('Erro', result.payload.response.data.errors[0]);
            } else {
              toastr.success('Sucesso', 'Horário de Verão enviado com sucesso.');
            }
          })
          .catch(e => {
            this.setState({ showModal: false });
            toastr.error('Erro', e);
          });
      }
    });
  }

  enviarFaseTempoControlador() {
    swal({
      title: 'Enviar as configurações de Tempos e Fases para a Central?',
      html: '<h5>Essa ação vai substituir as configurações existentes na central.</h5>',
      type: 'question',
      showCancelButton: true,
      confirmButtonColor: 'primary',
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: 'false',
    }).then(result => {
      if (result.value) {
        this.setState({ showModal: true }); // da show no modal de aguarde

        const dataTempo = {
          ip: this.props.enderecoUDP.ip,
          porta: this.props.enderecoUDP.porta,
          tempo_vermelho_min: window.$('#tempo_vermelho_min').val(),
          tempo_amarelo_min: window.$('#tempo_amarelo_min').val(),
          tempo_verde_min: window.$('#tempo_verde_min').val(),
          numCont: this.props.valores.numero_controlador,
          anel: this.props.valores.anel,
        };

        const dataFases = {
          ip: this.props.enderecoUDP.ip,
          porta: this.props.enderecoUDP.porta,
          fases: this.state.fases,
          numCont: this.props.valores.numero_controlador,
          anel: this.props.valores.anel,
          conflitos: [
            {
              numCont: this.props.valores.numero_controlador,
              numero_fases: this.props.valores.numero_fases,

              fase1: [
                this.props.valores.fase1_fase2 === true ? 1 : 0,
                this.props.valores.fase1_fase3 === true ? 1 : 0,
                this.props.valores.fase1_fase4 === true ? 1 : 0,
                this.props.valores.fase1_fase5 === true ? 1 : 0,
                this.props.valores.fase1_fase6 === true ? 1 : 0,
                this.props.valores.fase1_fase7 === true ? 1 : 0,
                this.props.valores.fase1_fase8 === true ? 1 : 0,
                this.props.valores.fase1_fase9 === true ? 1 : 0,
                this.props.valores.fase1_fase10 === true ? 1 : 0,
                this.props.valores.fase1_fase11 === true ? 1 : 0,
                this.props.valores.fase1_fase12 === true ? 1 : 0,
                this.props.valores.fase1_fase13 === true ? 1 : 0,
                this.props.valores.fase1_fase14 === true ? 1 : 0,
                this.props.valores.fase1_fase15 === true ? 1 : 0,
                this.props.valores.fase1_fase16 === true ? 1 : 0,
              ],

              fase2: [
                this.props.valores.fase2_fase3 === true ? 1 : 0,
                this.props.valores.fase2_fase4 === true ? 1 : 0,
                this.props.valores.fase2_fase5 === true ? 1 : 0,
                this.props.valores.fase2_fase6 === true ? 1 : 0,
                this.props.valores.fase2_fase7 === true ? 1 : 0,
                this.props.valores.fase2_fase8 === true ? 1 : 0,
                this.props.valores.fase2_fase9 === true ? 1 : 0,
                this.props.valores.fase2_fase10 === true ? 1 : 0,
                this.props.valores.fase2_fase11 === true ? 1 : 0,
                this.props.valores.fase2_fase12 === true ? 1 : 0,
                this.props.valores.fase2_fase13 === true ? 1 : 0,
                this.props.valores.fase2_fase14 === true ? 1 : 0,
                this.props.valores.fase2_fase15 === true ? 1 : 0,
                this.props.valores.fase2_fase16 === true ? 1 : 0,
              ],

              fase3: [
                this.props.valores.fase3_fase4 === true ? 1 : 0,
                this.props.valores.fase3_fase5 === true ? 1 : 0,
                this.props.valores.fase3_fase6 === true ? 1 : 0,
                this.props.valores.fase3_fase7 === true ? 1 : 0,
                this.props.valores.fase3_fase8 === true ? 1 : 0,
                this.props.valores.fase3_fase9 === true ? 1 : 0,
                this.props.valores.fase3_fase10 === true ? 1 : 0,
                this.props.valores.fase3_fase11 === true ? 1 : 0,
                this.props.valores.fase3_fase12 === true ? 1 : 0,
                this.props.valores.fase3_fase13 === true ? 1 : 0,
                this.props.valores.fase3_fase14 === true ? 1 : 0,
                this.props.valores.fase3_fase15 === true ? 1 : 0,
                this.props.valores.fase3_fase16 === true ? 1 : 0,
              ],

              fase4: [
                this.props.valores.fase4_fase5 === true ? 1 : 0,
                this.props.valores.fase4_fase6 === true ? 1 : 0,
                this.props.valores.fase4_fase7 === true ? 1 : 0,
                this.props.valores.fase4_fase8 === true ? 1 : 0,
                this.props.valores.fase4_fase9 === true ? 1 : 0,
                this.props.valores.fase4_fase10 === true ? 1 : 0,
                this.props.valores.fase4_fase11 === true ? 1 : 0,
                this.props.valores.fase4_fase12 === true ? 1 : 0,
                this.props.valores.fase4_fase13 === true ? 1 : 0,
                this.props.valores.fase4_fase14 === true ? 1 : 0,
                this.props.valores.fase4_fase15 === true ? 1 : 0,
                this.props.valores.fase4_fase16 === true ? 1 : 0,
              ],

              fase5: [
                this.props.valores.fase5_fase6 === true ? 1 : 0,
                this.props.valores.fase5_fase7 === true ? 1 : 0,
                this.props.valores.fase5_fase8 === true ? 1 : 0,
                this.props.valores.fase5_fase9 === true ? 1 : 0,
                this.props.valores.fase5_fase10 === true ? 1 : 0,
                this.props.valores.fase5_fase11 === true ? 1 : 0,
                this.props.valores.fase5_fase12 === true ? 1 : 0,
                this.props.valores.fase5_fase13 === true ? 1 : 0,
                this.props.valores.fase5_fase14 === true ? 1 : 0,
                this.props.valores.fase5_fase15 === true ? 1 : 0,
                this.props.valores.fase5_fase16 === true ? 1 : 0,
              ],

              fase6: [
                this.props.valores.fase6_fase7 === true ? 1 : 0,
                this.props.valores.fase6_fase8 === true ? 1 : 0,
                this.props.valores.fase6_fase9 === true ? 1 : 0,
                this.props.valores.fase6_fase10 === true ? 1 : 0,
                this.props.valores.fase6_fase11 === true ? 1 : 0,
                this.props.valores.fase6_fase12 === true ? 1 : 0,
                this.props.valores.fase6_fase13 === true ? 1 : 0,
                this.props.valores.fase6_fase14 === true ? 1 : 0,
                this.props.valores.fase6_fase15 === true ? 1 : 0,
                this.props.valores.fase6_fase16 === true ? 1 : 0,
              ],

              fase7: [
                this.props.valores.fase7_fase8 === true ? 1 : 0,
                this.props.valores.fase7_fase9 === true ? 1 : 0,
                this.props.valores.fase7_fase10 === true ? 1 : 0,
                this.props.valores.fase7_fase11 === true ? 1 : 0,
                this.props.valores.fase7_fase12 === true ? 1 : 0,
                this.props.valores.fase7_fase13 === true ? 1 : 0,
                this.props.valores.fase7_fase14 === true ? 1 : 0,
                this.props.valores.fase7_fase15 === true ? 1 : 0,
                this.props.valores.fase7_fase16 === true ? 1 : 0,
              ],

              fase8: [
                this.props.valores.fase8_fase9 === true ? 1 : 0,
                this.props.valores.fase8_fase10 === true ? 1 : 0,
                this.props.valores.fase8_fase11 === true ? 1 : 0,
                this.props.valores.fase8_fase12 === true ? 1 : 0,
                this.props.valores.fase8_fase13 === true ? 1 : 0,
                this.props.valores.fase8_fase14 === true ? 1 : 0,
                this.props.valores.fase8_fase15 === true ? 1 : 0,
                this.props.valores.fase8_fase16 === true ? 1 : 0,
              ],

              fase9: [
                this.props.valores.fase9_fase10 === true ? 1 : 0,
                this.props.valores.fase9_fase11 === true ? 1 : 0,
                this.props.valores.fase9_fase12 === true ? 1 : 0,
                this.props.valores.fase9_fase13 === true ? 1 : 0,
                this.props.valores.fase9_fase14 === true ? 1 : 0,
                this.props.valores.fase9_fase15 === true ? 1 : 0,
                this.props.valores.fase9_fase16 === true ? 1 : 0,
              ],

              fase10: [
                this.props.valores.fase10_fase11 === true ? 1 : 0,
                this.props.valores.fase10_fase12 === true ? 1 : 0,
                this.props.valores.fase10_fase13 === true ? 1 : 0,
                this.props.valores.fase10_fase14 === true ? 1 : 0,
                this.props.valores.fase10_fase15 === true ? 1 : 0,
                this.props.valores.fase10_fase16 === true ? 1 : 0,
              ],

              fase11: [
                this.props.valores.fase11_fase12 === true ? 1 : 0,
                this.props.valores.fase11_fase13 === true ? 1 : 0,
                this.props.valores.fase11_fase14 === true ? 1 : 0,
                this.props.valores.fase11_fase15 === true ? 1 : 0,
                this.props.valores.fase11_fase16 === true ? 1 : 0,
              ],

              fase12: [
                this.props.valores.fase12_fase13 === true ? 1 : 0,
                this.props.valores.fase12_fase14 === true ? 1 : 0,
                this.props.valores.fase12_fase15 === true ? 1 : 0,
                this.props.valores.fase12_fase16 === true ? 1 : 0,
              ],

              fase13: [
                this.props.valores.fase13_fase14 === true ? 1 : 0,
                this.props.valores.fase13_fase15 === true ? 1 : 0,
                this.props.valores.fase13_fase16 === true ? 1 : 0,
              ],

              fase14: [
                this.props.valores.fase14_fase15 === true ? 1 : 0,
                this.props.valores.fase14_fase16 === true ? 1 : 0,
              ],

              fase15: [this.props.valores.fase15_fase16 === true ? 1 : 0],

              // fase1: [
              //     this.props.valores.fase1_fase2 === true ? 1 : 0,
              //     this.props.valores.fase1_fase3 === true ? 1 : 0,
              //     this.props.valores.fase1_fase4 === true ? 1 : 0,
              //     this.props.valores.fase1_fase5 === true ? 1 : 0,
              //     this.props.valores.fase1_fase6 === true ? 1 : 0,
              //     this.props.valores.fase1_fase7 === true ? 1 : 0,
              //     this.props.valores.fase1_fase8 === true ? 1 : 0
              // ],
              // fase2: [
              //     this.props.valores.fase2_fase3 === true ? 1 : 0,
              //     this.props.valores.fase2_fase4 === true ? 1 : 0,
              //     this.props.valores.fase2_fase5 === true ? 1 : 0,
              //     this.props.valores.fase2_fase6 === true ? 1 : 0,
              //     this.props.valores.fase2_fase7 === true ? 1 : 0,
              //     this.props.valores.fase2_fase8 === true ? 1 : 0
              // ],
              // fase3: [
              //     this.props.valores.fase3_fase4 === true ? 1 : 0,
              //     this.props.valores.fase3_fase5 === true ? 1 : 0,
              //     this.props.valores.fase3_fase6 === true ? 1 : 0,
              //     this.props.valores.fase3_fase7 === true ? 1 : 0,
              //     this.props.valores.fase3_fase8 === true ? 1 : 0
              // ],
              // fase4: [
              //     this.props.valores.fase4_fase5 === true ? 1 : 0,
              //     this.props.valores.fase4_fase6 === true ? 1 : 0,
              //     this.props.valores.fase4_fase7 === true ? 1 : 0,
              //     this.props.valores.fase4_fase8 === true ? 1 : 0
              // ],
              // fase5: [
              //     this.props.valores.fase5_fase6 === true ? 1 : 0,
              //     this.props.valores.fase5_fase7 === true ? 1 : 0,
              //     this.props.valores.fase5_fase8 === true ? 1 : 0
              // ],
              // fase6: [
              //     this.props.valores.fase6_fase7 === true ? 1 : 0,
              //     this.props.valores.fase6_fase8 === true ? 1 : 0
              // ],
              // fase7: [
              //     this.props.valores.fase7_fase8 === true ? 1 : 0
              // ]
            },
          ],
        };

        this.props
          .enviarTemposControlador(dataTempo)
          .then(result => {
            if (result.error) {
              //se retornar true no erro, chama o metodo que pega do banco
              toastr.error('Erro', result.payload.response.data.errors[0]);
              this.setState({ showModal: false });
            } else {
              this.props
                .enviaDadosFasesControlador(dataFases)
                .then(resultFase => {
                  this.setState({ showModal: false });

                  if (resultFase.error) {
                    toastr.error('Erro', resultFase.payload.response.data.errors[0]);
                  } else {
                    this.props.handleSubmit();
                    // toastr.success('Sucesso', 'Tempos/Fases enviados com sucesso.');
                  }
                })
                .catch(Error => {
                  this.setState({ showModal: false });
                  toastr.error('Erro', Error);
                });
            }
          })
          .catch(e => {
            this.setState({ showModal: false });
            e.response.data.errors.forEach(error => toastr.error('Erro', error));
          });
      }
    });
  }

  async lerFaseTempoControlador() {
    const endereco = this.props.enderecoUDP;

    this.setState({
      showModal: true,
      messageModal: 'Lendo plano de segurança do controlador...',
      processingTagline: 'Plano de segurança',
    });

    await sleep(100);

    this.props
      .lerQuantidadeAneis(endereco, this.props.valores.numero_controlador, this.props.valores.anel)
      .catch(e => {
        this.setState({ showModal: false });
        toastr.error('Erro', 'Não foi possivel identificar a quantidade de aneis');
      })
      .then(async resultAnel => {
        if (resultAnel) {
          let erro = false;
          for (let idx = 0; idx < resultAnel.payload.data.quantidade && !erro; idx++) {
            let anelId = idx + 1;
            this.setState({ messageModal: `Buscando dados "Anel ${anelId}/${resultAnel.payload.data.quantidade}"` });
            this.props.valores.aneis[idx].ativo = 1;

            // this.props.lerTemposControlador(endereco, this.props.valores.numero_controlador, this.props.valores.anel)
            await this.props
              .lerTemposControlador(endereco, this.props.valores.numero_controlador, anelId)
              .then(async result => {
                if (result.error) {
                  //se retornar true no erro, chama o metodo que pega do banco
                  toastr.error('Erro', result.payload.response.data.errors[0]);
                  this.setState({ showModal: false, messageModal: '' });
                } else {
                  await this.props
                    .lerDadosFasesControlador(endereco, this.props.valores.numero_controlador, anelId)
                    // this.props.lerDadosFasesControlador(endereco, this.props.valores.numero_controlador, this.props.valores.anel)
                    .then(async resultFase => {
                      // this.setState({ showModal: false, messageModal:'' });
                      let bSucesso = false;

                      if (resultFase.error) {
                        toastr.error('Erro', resultFase.payload.response.data.errors[0]);
                        this.setState({ showModal: false, messageModal: '' });
                      } else {
                        let faseInicial = parseInt(resultFase.payload.data[0].fases_vermelho.inicio_fase);
                        let faseFinal = parseInt(resultFase.payload.data[0].fases_vermelho.total_fases);
                        const idxAnel = anelId - 1;

                        // IMPORTANTE: Carregar fases do banco ANTES de processar, se ainda não estiverem carregadas
                        // Agora que temos faseInicial e faseFinal corretos, podemos buscar as fases certas do banco
                        const idCont = this.props.valores.aneis[idxAnel].id || this.props.controladorId;

                        if (
                          (!this.props.valores.aneis[idxAnel].fases ||
                            this.props.valores.aneis[idxAnel].fases.length === 0) &&
                          idCont
                        ) {
                          // Carregar fases do banco de dados com os valores corretos de faseInicial e faseFinal
                          const resultFasesBanco = await this.props.getFaseList(idCont, faseInicial, faseFinal);

                          if (!resultFasesBanco.error && resultFasesBanco.payload && resultFasesBanco.payload.data) {
                            // Filtrar apenas as fases que pertencem a este anel (faseInicial a faseFinal)
                            const fasesDoAnel = resultFasesBanco.payload.data.filter(
                              fase => fase.id >= faseInicial && fase.id <= faseFinal,
                            );

                            this.props.valores.aneis[idxAnel].fases = fasesDoAnel;
                          }
                        }

                        // Preservar fases existentes do state (que vem do banco) para manter lat/lng
                        // Usar this.state.fases ao invés de aneis[].fases pois o state tem as coordenadas do banco
                        let dataFase =
                          anelId === this.props.valores.anel
                            ? this.state.fases.map(fase => ({ ...fase }))
                            : (this.props.valores.aneis[anelId - 1].fases || []).map(fase => ({ ...fase }));

                        // Percorre a lista "fases_vermelho" porque tem o mesmo número de posições
                        // da lista "fases_piscantes", então conseguimos acessar as propriedades de ambas as listas
                        for (let index = faseInicial; index <= faseFinal; index++) {
                          // Buscar fase existente pelo id ao invés de usar posição do array
                          const faseExistente = dataFase.find(f => f.id === index);

                          if (faseExistente) {
                            // Atualizar fase existente PRESERVANDO latitude e longitude
                            faseExistente.ausencia_vermelho = resultFase.payload.data[0].fases_vermelho[index];
                            faseExistente.cor_piscante = resultFase.payload.data[0].fases_piscantes[index];
                            faseExistente.tipo =
                              resultFase.payload.data[0].fases_piscantes[index] === 4 ? 2 : 1;
                            faseExistente.tempo_vermelho_min = resultFase.payload.data[0].fases_tempoMinimo[index].vrm;
                            faseExistente.tempo_amarelo_min = resultFase.payload.data[0].fases_tempoMinimo[index].amr;
                            faseExistente.tempo_verde_min = resultFase.payload.data[0].fases_tempoMinimo[index].vrd;
                            // NÃO sobrescrever latitude e longitude - manter os valores existentes
                          } else {
                            // Fase nova - criar com lat/lng zerados (serão preenchidos depois se necessário)
                            dataFase.push({
                              controlador_id: this.props.controladorId || 0,
                              id: index,
                              ausencia_vermelho: resultFase.payload.data[0].fases_vermelho[index],
                              cor_piscante: resultFase.payload.data[0].fases_piscantes[index],
                              cor_piscante_pedestre: 4,
                              ativo: 0,
                              latitude: 0,
                              longitude: 0,
                              tipo: resultFase.payload.data[0].fases_piscantes[index] === 4 ? 2 : 1,
                              tempo_vermelho_min: resultFase.payload.data[0].fases_tempoMinimo[index].vrm,
                              tempo_amarelo_min: resultFase.payload.data[0].fases_tempoMinimo[index].amr,
                              tempo_verde_min: resultFase.payload.data[0].fases_tempoMinimo[index].vrd,
                            });
                          }
                          // } else {
                          //     dataFase[index - 1].ausencia_vermelho = resultFase.payload.data[0].fases_vermelho[index];
                          //     dataFase[index - 1].cor_piscante = resultFase.payload.data[0].fases_piscantes[index];
                          // }
                        }

                        // Mantém só as fases do intervalo lido: sobras de uma leitura
                        // anterior com mais fases faziam o grid mostrar quantidade errada
                        dataFase = this.aplicaCoordenadasNasFases(
                          dataFase
                            .filter(f => f.id >= faseInicial && f.id <= faseFinal)
                            .sort((a, b) => a.id - b.id),
                        );

                        // this.props.valores.fases = dataFase;
                        this.props.valores.aneis[idxAnel].endereco = '';
                        this.props.valores.aneis[idxAnel].cruzamento = '';
                        this.props.valores.aneis[idxAnel].fases = dataFase; //o array de anel inicia de 0
                        this.props.valores.aneis[idxAnel].numero_fases = faseInicial; //o array de anel inicia de 0
                        this.props.valores.aneis[idxAnel].numero_fases_fim = faseFinal; //o array de anel inicia de 0
                        this.props.change('numero_fases', faseInicial);
                        this.props.change('numero_fases_fim', faseFinal);

                        // let totalFase = parseInt(resultFase.payload.data[0].fases_vermelho.total_fases);

                        // marca os conflitos das fases
                        for (let f = faseInicial + 1; f <= faseFinal; f++) {
                          for (let i = faseInicial; i < f; i++) {
                            const fieldName = `fase${i}_fase${f}`;
                            const rawConflito = resultFase.payload.data[0].fases_conflitantes[fieldName];
                            if (rawConflito === undefined || rawConflito === null) continue;

                            const marcado = rawConflito === 1;
                            this.props.valores.aneis[idxAnel][fieldName] = marcado;
                            this.props.change(fieldName, marcado);
                          }
                        }

                        this.setState({
                          fases: dataFase,
                          html: this.montaHtmlFases(dataFase, this.props.controladorId, {
                            faseInicial,
                            totalFase: dataFase.length,
                          }),
                        });

                        if (
                          (result.payload.data[0].tempo_vermelho_min !== null && result.payload.data[0].tempo_vermelho_min !== undefined) &&
                          (result.payload.data[0].tempo_amarelo_min !== null && result.payload.data[0].tempo_amarelo_min !== undefined) &&
                          (result.payload.data[0].tempo_verde_min !== null && result.payload.data[0].tempo_verde_min !== undefined)
                        ) {
                          bSucesso = true;

                          this.props.valores.aneis[idxAnel].tempo_vermelho_min =
                            result.payload.data[0].tempo_vermelho_min;
                          this.props.valores.aneis[idxAnel].tempo_amarelo_min =
                            result.payload.data[0].tempo_amarelo_min;
                          this.props.valores.aneis[idxAnel].tempo_verde_min = result.payload.data[0].tempo_verde_min;

                          this.props.change('tempo_vermelho_min', result.payload.data[0].tempo_vermelho_min);
                          this.props.change('tempo_amarelo_min', result.payload.data[0].tempo_amarelo_min);
                          this.props.change('tempo_verde_min', result.payload.data[0].tempo_verde_min);
                        } else {
                          toastr.error('Erro', 'Não foi possível realizar a leitura, tente novamente.');
                        }

                        if (bSucesso) {
                          toastr.success('Sucesso', 'Fases e Tempos lidos com sucesso.');
                        }
                      }
                    })
                    .catch(err => {
                      erro = true;
                      toastr.error('Erro', 'Erro ao ler fases do controlador');
                      this.setState({ showModal: false, messageModal: '' });
                    });
                }
              })
              .catch(e => {
                erro = true;
                this.setState({ showModal: false, messageModal: '' });
                toastr.error('Erro', 'Erro ao ler tempos do controlador');
              });
          }

          // se a quantidade for menor que 4 tem que desativar as outras
          for (let idx = resultAnel.payload.data.quantidade; idx < 4; idx++) {
            if (this.props.valores.aneis[idx]) {
              this.props.valores.aneis[idx].ativo = 0;
            }
          }

          // se tudo der certo termina o modal de processando
          this.setState({ showModal: false, messageModal: '' });

          // NÃO limpar aneis[].fases nem recarregar do banco: tempos/cores
          // lidos do equipamento ainda não estão no DB (só vão no Salvar).
          const anelAtual = this.props.valores.anel - 1;
          const anelLido = this.props.valores.aneis[anelAtual];
          const fasesLidas = this.aplicaCoordenadasNasFases(
            (anelLido && anelLido.fases ? anelLido.fases : []).map(f => ({ ...f })),
          );

          if (anelLido) {
            anelLido.fases = fasesLidas;
            this.props.change('numero_fases', anelLido.numero_fases);
            this.props.change('numero_fases_fim', anelLido.numero_fases_fim);
            this.props.change('tempo_vermelho_min', anelLido.tempo_vermelho_min);
            this.props.change('tempo_amarelo_min', anelLido.tempo_amarelo_min);
            this.props.change('tempo_verde_min', anelLido.tempo_verde_min);
          }

          const idCont =
            (anelLido && anelLido.id) || this.props.controladorId || 0;

          this.setState({
            fases: fasesLidas,
            html: this.montaHtmlFases(fasesLidas, idCont, {
              faseInicial: anelLido && anelLido.numero_fases,
              totalFase: fasesLidas.length,
            }),
            carregouFase: true,
          });
        } else {
          toastr.error('Erro', 'Perda de conexão. Não foi possível realizar a leitura, tente novamente.');
          this.setState({ showModal: false, messageModal: '' });
        }
      });
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  async handleShow() {
    this.setState({
      htmlMapaCont: <div>Carregando...</div>,
    });

    const hasValidCoords =
      Number.isFinite(this.props.latitude) &&
      Number.isFinite(this.props.longitude) &&
      !(this.props.latitude === 0 && this.props.longitude === 0);

    let finalLat = this.state.cepLat;
    let finalLng = this.state.cepLng;

    if (!hasValidCoords) {
      if (this.props.cep) {
        // Geocodifica pelo CEP antes de renderizar o mapa
        try {
          const result = await this.props.getLocalCEP(this.props.cep);
          const loc = result && result.payload && result.payload.data && result.payload.data.location;
          if (loc && typeof loc.lat === 'number' && typeof loc.lng === 'number') {
            finalLat = loc.lat;
            finalLng = loc.lng;
            this.setState({ cepLat: finalLat, cepLng: finalLng });
          }
        } catch (erro) {
          toastr.error('Erro', 'Não foi possível localizar o CEP informado.');
        }
      } else {
        toastr.warning('Alerta', 'Informe o campo CEP');
        return; // Não abre o modal se não tem CEP
      }
    } else {
      // Usa coordenadas já salvas
      finalLat = this.props.latitude;
      finalLng = this.props.longitude;
      this.setState({ cepLat: finalLat, cepLng: finalLng });
    }

    await sleep(100);

    this.setState({
      htmlMapaCont: (
        <MapaControlador
          data-contId={this.props.controladorId}
          data-latitude={finalLat}
          data-longitude={finalLng}
          latitude={finalLat}
          longitude={finalLng}
          onPositionChange={(lat, lng) => {
            // Mantém lat/lng atualizados enquanto o usuário arrasta o marcador
            this.setState({ cepLat: lat, cepLng: lng });
          }}
        />
      ),
      show: true,
    });
  }

  handleShowModal() {
    this.setState({ showModal: true });
  }

  handleShowTab(name) {
    this.setState({ showTab: name });
  }

  handleShowIdentTab(name) {
    this.setState({ showIdentTab: name });
  }

  renderMonitoramentoFields() {
    const { config } = this.props;

    const toggles = [
      {
        name: 'monitora_erro',
        icon: 'fa-wifi',
        title: 'Monitora Conexão',
        description: 'Gera alertas quando a comunicação com o controlador for perdida ou restabelecida.',
      },
      {
        name: 'nobreak',
        icon: 'fa-bolt',
        title: 'Nobreak',
        description: 'Indica que o equipamento possui nobreak instalado no local.',
      },
    ];

    if (config && config.modulo_pluviometrico) {
      toggles.push({
        name: 'pluviometrico_ativo',
        icon: 'fa-tint',
        title: 'Pluviômetro',
        description:
          'Detectado automaticamente no equipamento (sincronização periódica ou teste de conexão). Não pode ser alterado manualmente.',
        component: ControladorMonitoramentoToggle,
        readOnly: true,
      });
    }

    if (config && config.modulo_divergencia_programacao) {
      toggles.push({
        name: 'monitora_divergencia_programacao',
        icon: 'fa-code-branch',
        title: 'Divergência de Programação',
        description: 'Compara a programação central com o equipamento.',
      });
    }

    return (
      <div className="controlador-ident-monitoramento-panel">
        <div className="controlador-ident-monitoramento-grid">
          {toggles.map(toggle => (
            <Field
              key={toggle.name}
              name={toggle.name}
              component={toggle.component || ControladorMonitoramentoToggle}
              type="checkbox"
              icon={toggle.icon}
              title={toggle.title}
              description={toggle.description}
              readOnly={toggle.readOnly}
            />
          ))}
        </div>
      </div>
    );
  }

  async clickOk() {
    // Prioriza valores mantidos no state via onPositionChange; se ausentes, lê dos campos ocultos
    const lat = (this.state.cepLat !== null && this.state.cepLat !== undefined) ? this.state.cepLat : parseFloat(window.$('#controador_latitude').val());
    const lng = (this.state.cepLng !== null && this.state.cepLng !== undefined) ? this.state.cepLng : parseFloat(window.$('#controador_longitude').val());

    this.props.change('latitude', lat);
    this.props.change('longitude', lng);

    this.setState({
      cepLat: lat,
      cepLng: lng,
      // Localização marcada no mapa supre o CEP que não foi localizado
      cepErro: this.numeroCoordenada(lat) === 0 && this.numeroCoordenada(lng) === 0 ? this.state.cepErro : '',
    });

    if (!this.props.controladorId) {
      this.setState({
        html: <div>Carregando...</div>,
      });

      await sleep(100);

      const fasesAtualizadas = (this.state.fases || []).map(fase => ({
        ...fase,
        latitude: this.numeroCoordenada(lat),
        longitude: this.numeroCoordenada(lng),
      }));

      this.setState({
        fases: fasesAtualizadas,
        html: this.montaHtmlFases(fasesAtualizadas, this.props.controladorId, {
          totalFase: this.props.numeroFases,
        }),
      });
    }

    this.setState({ show: false });
  }

  renderMarker(lat, lng) {
    const list = this.props.getList() || [];

    return list.map(contro => (
      <Marker
        position={{ lat: contro.latitude, lng: contro.longitude }} //{ lat: -27.217136, lng: -49.644149 }
        draggable={true}
        icon={'http://maps.google.com/mapfiles/ms/icons/green-dot.png'}
        onMouseUp={this.handleMarkerMouseUp}
      />
    ));
  }

  onBlurVerdeMinimo(event) {
    let tempo_verde_arredondado = window.$('#tempo_verde_min').val();
    tempo_verde_arredondado = Math.round(tempo_verde_arredondado);

    window.$('#tempo_verde_min').val(parseInt(tempo_verde_arredondado));
  }

  // submitForm() {
  //     this.props.create();
  // }

  // Sempre passa o array explícito. Usar this.state.fases logo após setState
  // entrega o valor anterior (stale) e o grid volta a mostrar tempos zerados do banco.
  montaHtmlFases(fases, idCont, opcoes = {}) {
    const fasesRender = Array.isArray(fases) ? fases.map(fase => ({ ...fase })) : [];
    const faseInicial = opcoes.faseInicial;
    const totalFase =
      (opcoes.totalFase !== null && opcoes.totalFase !== undefined)
        ? opcoes.totalFase
        : fasesRender.length || this.props.numeroFases;

    return (
      <ListFase
        data-id={idCont}
        data-ini-fase={faseInicial}
        data-total-fase={totalFase}
        data-fases={fasesRender}
        data-controlador-lat={this.props.latitude}
        data-controlador-lng={this.props.longitude}
        onFasesChange={novasFases => this.setState({ fases: novasFases })}
      />
    );
  }

  aplicaCoordenadasNasFases(fases) {
    if (!Array.isArray(fases)) return [];

    const latControlador = this.numeroCoordenada(this.state.cepLat || this.props.latitude);
    const lngControlador = this.numeroCoordenada(this.state.cepLng || this.props.longitude);

    return fases.map(fase => {
      const copia = { ...fase };
      const latAtual = copia.latitude;
      if (!latAtual || latAtual === 0 || latAtual === '0' || parseFloat(latAtual) === 0) {
        copia.latitude = latControlador;
      } else {
        copia.latitude = this.numeroCoordenada(latAtual);
      }

      const lngAtual = copia.longitude;
      if (!lngAtual || lngAtual === 0 || lngAtual === '0' || parseFloat(lngAtual) === 0) {
        copia.longitude = lngControlador;
      } else {
        copia.longitude = this.numeroCoordenada(lngAtual);
      }

      return copia;
    });
  }

  async geraGridFase(anelSelect) {
    this.setState({
      html: <div>Carregando...</div>,
    });

    await sleep(100);

    let idCont = this.props.valores.aneis[anelSelect].id
      ? this.props.valores.aneis[anelSelect].id
      : this.props.controladorId;

    if (this.props.valores.aneis[anelSelect].fases && this.props.valores.aneis[anelSelect].fases.length) {
      const fasesCopy = this.aplicaCoordenadasNasFases(
        this.props.valores.aneis[anelSelect].fases.map(fase => ({ ...fase })),
      );

      this.props.valores.aneis[anelSelect].fases = fasesCopy;
      this.setState({
        fases: fasesCopy,
        OldFases: JSON.parse(JSON.stringify(fasesCopy)),
        html: this.montaHtmlFases(fasesCopy, idCont),
        carregouFase: true,
      });
      this.agendarBaselineInicial();
    } else {
      if ((idCont !== null && idCont !== undefined)) {
        this.props
          .getFaseList(
            idCont,
            this.props.valores.aneis[anelSelect].numero_fases,
            this.props.valores.aneis[anelSelect].numero_fases_fim,
          )
          .then(resultFase => {
            const fasesCopy = this.aplicaCoordenadasNasFases(resultFase.payload.data || []);
            this.props.valores.aneis[anelSelect].fases = fasesCopy;
            this.setState({
              fases: fasesCopy,
              OldFases: JSON.parse(JSON.stringify(fasesCopy)),
              html: this.montaHtmlFases(fasesCopy, idCont),
              carregouFase: true,
            });
            this.agendarBaselineInicial();
          });
      } else {
        this.props
          .getFaseListNovo(
            this.props.valores.aneis[anelSelect].numero_fases,
            this.props.valores.aneis[anelSelect].numero_fases_fim,
          )
          .then(resultFase => {
            const fasesLidas = this.aplicaCoordenadasNasFases(
              (resultFase.payload.data || []).map(f => ({ ...f })),
            );
            this.props.valores.aneis[anelSelect].fases = fasesLidas;
            this.setState({
              fases: fasesLidas,
              OldFases: fasesLidas.map(f => ({ ...f })),
              dirtyFases: false,
              html: this.montaHtmlFases(fasesLidas, idCont, { totalFase: fasesLidas.length }),
              carregouFase: true,
            });
            this.agendarBaselineInicial();
          });
      }
    }
  }

  componentWillMount() {
    // Se tem controladorId, está editando → limpar cache fases todos anéis antes de gerar grid
    if (this.props.controladorId && this.props.valores && this.props.valores.aneis) {
      this.props.valores.aneis.forEach(anel => {
        if (anel) {
          anel.fases = []; // Força reload do banco para cada anel
        }
      });
    }

    this.geraGridFase(0); // posição zero anel padrão 1
  }

  verificaAlteracao() {
    for (const key in this.state.OldValues) {
      if (key.indexOf('_fase') >= 0) {
        if (this.state.OldValues[key] !== this.props.valores[key]) {
          return true;
        }
      }
    }

    if (
      this.state.OldValues.tempo_amarelo_min !== this.props.valores.tempo_amarelo_min ||
      this.state.OldValues.tempo_verde_min !== this.props.valores.tempo_verde_min ||
      this.state.OldValues.tempo_vermelho_min !== this.props.valores.tempo_vermelho_min ||
      this.state.OldValues.numero_fases !== this.props.valores.numero_fases
    ) {
      return true;
    }

    if (this.fasesForamAlteradas()) {
      return true;
    }

    return false;
  }

  syncConflitosAnelCorrenteDoForm() {
    if (!this.props.valores || !this.props.valores.aneis) return;
    syncConflitosFormParaAnel(this.props.valores, this.props.valores.anel - 1);
  }

  consolidarConflitosNoFormulario() {
    if (!this.props.valores || !this.props.valores.aneis) return;
    this.syncConflitosAnelCorrenteDoForm();
    consolidarConflitosAneisNoForm(this.props.valores.aneis, this.props.change);
  }

  async aguardarConflitosDoAnel(anelIndex) {
    await sleep(150);
    syncConflitosAnelParaForm(this.props.valores.aneis, anelIndex, this.props.change);
    await sleep(50);
  }

  anelChange(anel) {
    // let anel = event.target.value - 1;

    // Manter endereço e cruzamento existentes se já estiverem preenchidos
    const enderecoAtual = this.props.valores.endereco;
    const cruzamentoAtual = this.props.valores.cruzamento;

    if (!enderecoAtual || enderecoAtual.trim() === '') {
      this.props.change('endereco', this.props.valores.aneis[anel].endereco);
    }
    if (!cruzamentoAtual || cruzamentoAtual.trim() === '') {
      this.props.change('cruzamento', this.props.valores.aneis[anel].cruzamento);
    }

    this.props.change('numero_fases', this.props.valores.aneis[anel].numero_fases);
    this.props.change('numero_fases_fim', this.props.valores.aneis[anel].numero_fases_fim);

    this.props.change('tempo_vermelho_min', this.props.valores.aneis[anel].tempo_vermelho_min);
    this.props.change('tempo_amarelo_min', this.props.valores.aneis[anel].tempo_amarelo_min);
    this.props.change('tempo_verde_min', this.props.valores.aneis[anel].tempo_verde_min);

    this.geraGridFase(anel);
  }

  // O banco sempre mantém as 4 linhas de anel. Se a leitura do plano de
  // segurança encontrar menos anéis no hardware, os demais vão inativos.
  garantirQuatroAneis() {
    if (!this.props.valores) return;
    if (!Array.isArray(this.props.valores.aneis)) {
      this.props.valores.aneis = [];
    }

    const aneis = this.props.valores.aneis;

    for (let idx = 0; idx < 4; idx++) {
      if (!aneis[idx]) {
        aneis[idx] = {
          anel: idx + 1,
          endereco: '',
          cruzamento: '',
          numero_fases: 0,
          numero_fases_fim: 0,
          tempo_vermelho_min: 1,
          tempo_amarelo_min: 3,
          tempo_verde_min: 3,
          ativo: 0,
          fases: [],
          imageLog: 'in',
        };
      } else {
        aneis[idx].anel = idx + 1;
        if (!Array.isArray(aneis[idx].fases)) {
          aneis[idx].fases = [];
        }
      }
    }

    aneis.length = 4;

    const anelSelecionado = parseInt(this.props.valores.anel, 10);
    if (!Number.isFinite(anelSelecionado) || anelSelecionado < 1 || anelSelecionado > 4) {
      this.props.valores.anel = 1;
    }
  }

  sanitizarCoordenadasDosAneis() {
    if (!this.props.valores || !Array.isArray(this.props.valores.aneis)) return;

    this.props.valores.aneis.forEach(anel => {
      if (!anel || !Array.isArray(anel.fases)) return;
      anel.fases.forEach(fase => {
        fase.latitude = this.numeroCoordenada(fase.latitude);
        fase.longitude = this.numeroCoordenada(fase.longitude);
      });
    });
  }

  async salvarControlador() {
    if (this.state.cepErro) {
      swal({
        type: 'warning',
        title: 'CEP inválido',
        text: this.state.cepErro,
      });
      return;
    }

    const latControlador = this.numeroCoordenada(this.state.cepLat || this.props.latitude);
    const lngControlador = this.numeroCoordenada(this.state.cepLng || this.props.longitude);

    // Só bloqueia no cadastro novo: controlador já gravado não pode travar por
    // coordenada zerada em base antiga
    if (!this.props.valores.id && latControlador === 0 && lngControlador === 0) {
      swal({
        type: 'warning',
        title: 'Localização não definida',
        text: 'Informe um CEP válido ou marque a localização no mapa antes de salvar.',
      });
      return;
    }

    this.garantirQuatroAneis();
    const anelList = this.props.valores.aneis;
    let anelValid = true;

    // o anel atual recebe a fase do state para gravar corretamento a longitudo e latitude
    // Fazer cópia profunda para evitar referências compartilhadas
    this.syncConflitosAnelCorrenteDoForm();
    this.props.valores.aneis[this.props.valores.anel - 1].fases = this.state.fases.map(fase => ({ ...fase }));

    // Sincronizar endereço e cruzamento do formulário para TODOS os anéis ativos
    // pois a validação verifica todos os anéis e o endereço/cruzamento são compartilhados
    const enderecoAtual = this.props.valores.endereco || '';
    const cruzamentoAtual = this.props.valores.cruzamento || '';
    for (const idx in anelList) {
      if (anelList[idx].ativo === 1) {
        anelList[idx].endereco = enderecoAtual;
        anelList[idx].cruzamento = cruzamentoAtual;
      }
    }

    for (const idx in anelList) {
      if (anelList[idx].ativo === 1) {
        if (anelList[idx].numero_fases === anelList[idx].numero_fases_fim) {
          this.props.change('anel', anelList[idx].anel);
          this.anelChange(anelList[idx].anel - 1);
          anelValid = false;
          swal({
            type: 'warning',
            title: 'Fases inicial e final não podem ser iguais',
          });
          break;
        }

        if (anelList[idx].endereco.trim() === '' || anelList[idx].cruzamento.trim() === '') {
          this.props.change('anel', anelList[idx].anel);
          this.anelChange(anelList[idx].anel - 1);
          anelValid = false;

          swal({
            type: 'warning',
            title: 'Informe os campos obrigatórios "Endereço" e "Cruzamento"',
          });
          break;
        }
      }
    }

    if (anelValid) {
      if (!this.props.valid) {
        swal({
          type: 'warning',
          title: 'Informe os campos obrigatórios',
        });
        this.props.handleSubmit(); // fica aqui para pintar os campo em vermelho
      } else {
        this.props.valores.fases = this.state.fases;

        this.setState({
          showModal: true,
          messageModal: 'Preparando dados para salvar...',
          processingTagline: 'Salvando controlador',
        });

        // carrega a foto de todos os aneis
        for (const key in anelList) {
          if (parseInt(anelList[key].ativo) === 1) {
            this.setState({ carregouFase: false });
            await sleep(200);
            this.props.change('anel', anelList[key].anel);
            this.anelChange(anelList[key].anel - 1);
            // await sleep(400);
            while (!this.state.carregouFase) {
              await sleep(400);
            }
            await this.aguardarConflitosDoAnel(anelList[key].anel - 1);

            // Salvar as fases do anel atual após carregar, garantindo que lat/long sejam salvas corretamente
            // Fazer cópia profunda para evitar referências compartilhadas
            const anelIndex = anelList[key].anel - 1;
            this.props.valores.aneis[anelIndex].fases = this.state.fases.map(fase => ({ ...fase }));

            try {
              await html2canvas(this.componentRef.current, {
                allowTaint: true,
                useCORS: true,
                logging: true,
                ignoreElements: element => {
                  if (element.tagName === 'IMG' && element.src.includes('localhost:3000')) {
                    return true;
                  }
                  return false;
                },
              }).then(canvas => {
                canvas.style.display = 'none';
                let image = canvas.toDataURL('png');
                this.props.valores.aneis[key].imageLog = image;
                anelList[key].imageLog = image;
              });
            } catch (error) {
              console.error('Erro ao capturar imagem com html2canvas:', error);
              this.props.valores.aneis[key].imageLog = null;
              anelList[key].imageLog = null;
            }
          }
        }

        this.consolidarConflitosNoFormulario();
        this.sanitizarCoordenadasDosAneis();

        this.setState({
          messageModal: 'Atualizando controlador, anéis, planos e fases...',
          processingDetail: 'Aguarde, este processo é longo e pode levar algum tempo.',
          processingTagline: 'Salvando controlador',
        });

        try {
          await this.executarSubmitControlador();

          if (this.verificaAlteracao()) {
            this.setState({
              fases: [],
              html: <div />,
            });
          }
        } catch (error) {
          if (error && typeof error === 'object' && !Array.isArray(error)) {
            console.error('Erro ao salvar controlador:', error);
          }
        } finally {
          this.setState({
            showModal: false,
            messageModal: '',
            processingDetail: '',
            processingTagline: 'Controlador',
          });
        }
      }
    }
  }

  // Coordenada sempre numérica: o backend grava em decimal(9,6) e quebrava
  // quando recebia string (campo de tela) ou undefined (CEP sem geocodificação)
  numeroCoordenada(valor) {
    const numero = parseFloat(valor);
    return Number.isFinite(numero) ? numero : 0;
  }

  carregaLatLngFase() {
    const dataFases = this.aplicaCoordenadasNasFases(this.state.fases);
    this.setState({ fases: dataFases });
    return dataFases;
  }

  carregaLatLngFaseInsert() {
    const lat = this.numeroCoordenada(this.state.cepLat);
    const lng = this.numeroCoordenada(this.state.cepLng);
    const dataFases = (this.state.fases || []).map(fase => ({
      ...fase,
      latitude: lat,
      longitude: lng,
    }));
    this.setState({ fases: dataFases });
    return dataFases;
  }

  cepOnBlur(event) {
    if ((this.props.latitude === null || this.props.latitude === undefined) || event.target.value !== this.state.cep) {
      if (event.target.value) {
        const cepDigitado = String(event.target.value).replace(/\D/g, '');

        this.setState({ cep: event.target.value });

        if (cepDigitado.length !== 8) {
          this.marcarCepInvalido('CEP inválido. Informe os 8 dígitos.');
          return;
        }

        this.setState({ cepErro: '' });

        this.props
          .getLocalCEP(cepDigitado)
          .then(result => {
            const location = result && result.payload && result.payload.data && result.payload.data.location;
            const lat = this.numeroCoordenada(location && location.lat);
            const lng = this.numeroCoordenada(location && location.lng);

            // Sem coordenada não há como gravar as fases: trata como CEP inválido
            if (lat === 0 && lng === 0) {
              this.marcarCepInvalido('CEP não localizado. Confira o CEP informado.');
              return;
            }

            this.setState({ cepLat: lat, cepLng: lng, cepErro: '' }, () => {
              this.props.change('latitude', lat);
              this.props.change('longitude', lng);

              const fasesAtualizadas = this.aplicaCoordenadasNasFases(this.state.fases);
              this.setState({
                fases: fasesAtualizadas,
                html: this.montaHtmlFases(fasesAtualizadas, this.props.controladorId, {
                  totalFase: fasesAtualizadas.length,
                }),
              });
            });
          })
          .catch(erro => {
            const mensagem =
              (erro.response && erro.response.data && erro.response.data.errors && erro.response.data.errors[0]) ||
              'Não foi possível localizar o CEP informado.';
            this.marcarCepInvalido(mensagem);
          });
      }
    }
  }

  // Deixa o CEP em estado inválido: sem coordenada o cadastro não pode seguir
  marcarCepInvalido(mensagem) {
    this.setState({ cepErro: mensagem, cepLat: 0, cepLng: 0 });
    this.props.change('latitude', null);
    this.props.change('longitude', null);
    toastr.error('CEP', mensagem);
  }

  renderFieldLaco() {
    let lacos = [];

    for (let index = 1; index <= 16; index++) {
      let name = 'laco_' + index,
        label = 'Laço ' + index;

      lacos.push(
        <Field
          name={name}
          id={name}
          component={LabelAndInput}
          label={label}
          cols="12 6"
          placeholder="Informe a descrição do laço"
        />,
      );
    }
    return lacos;
  }

  croquiHandleFileChange(event) {
    const croquiFileSelected = event.target.files[0];

    if (croquiFileSelected) {
      // Verificar se o arquivo é um PDF
      if (croquiFileSelected.type !== 'application/pdf') {
        this.setState({
          croquiFileSelected: null,
          croquiFileErrorMessage: 'Por favor, selecione um arquivo PDF.',
        });
        return;
      }

      // Verificar o tamanho do arquivo (1 MB = 1048576 bytes)
      if (croquiFileSelected.size > 1048576) {
        this.setState({
          croquiFileSelected: null,
          croquiFileErrorMessage: 'O arquivo selecionado excede o tamanho máximo permitido (1 MB).',
        });
        return;
      }

      this.setState({
        croquiFileSelected,
        croquiFileErrorMessage: '',
      });

      const reader = new FileReader();
      reader.readAsDataURL(croquiFileSelected);
      reader.onload = () => {
        const croquiFileBase64 = reader.result;
        this.props.change('croqui_file_data', croquiFileBase64);
      };
      reader.onerror = () => {
        console.error('Erro ao ler o arquivo.');
      };
    }
  }
  deleteCroquiFile() {
    this.props.change('croqui_file_id', null);
    this.setState({ showCroquiDeleteWarning: true });
  }

  async getPdf(croqui_file_id) {
    try {
      // O croqui_file_id já é apenas o nome do arquivo (ex.: croqui-1.pdf)
      const encodedCroquiFileId = encodeURIComponent(croqui_file_id);
      const response = await this.props.getImageCroquiById(encodedCroquiFileId);

      if (response) {
        // Cria um URL temporário para o blob retornado pela API
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

        // Cria um link temporário e o clica para abrir o PDF em uma nova aba
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('target', '_blank');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error('Erro ao visualizar o arquivo');
      }
    } catch (error) {
      console.error('Erro ao visualizar o arquivo:', error);
    }
  }

  renderFileInput({ input, meta }) {
    // Busca o croqui_file_id de múltiplas fontes
    const croquiIdFromInput = input.value;
    const croquiIdFromProps = this.props.croqui_file_id;

    // Usa input.value primeiro (quando há valor no form), senão usa props
    const croquiId = croquiIdFromInput || croquiIdFromProps;

    // Validação simples e direta
    const hasCroquiFile = Boolean(croquiId && croquiId.trim() && croquiId !== 'null');

    return (
      <div>
        {hasCroquiFile ? (
          <div>
            <label>Croqui processado:</label>
            <input name="croqui_file_id" className="form-control" readOnly={true} value={croquiId} />
            <br />
            <Button
              type="button"
              className="success btn"
              icon="search"
              label="Visualizar croqui"
              onClick={async () => this.getPdf(croquiId)}
            />
            <Button
              type="button"
              className="danger"
              icon="trash-alt"
              label="Deletar croqui"
              onClick={this.deleteCroquiFile}
            />
          </div>
        ) : (
          <input name="croqui_file" id="croqui_file" type="file" onChange={this.croquiHandleFileChange} />
        )}
      </div>
    );
  }

  render() {
    // const required = value => (value || typeof value === 'number' ? undefined : 'Required');
    const required = value => (value ? undefined : 'Obrigatório');

    const requiredSelect = value => (value === 'selecione' || (value === undefined || value === null) ? 'Obrigatório' : undefined);
    // const requiredSelect1 = value => (value === '' ? 'Required' : undefined);

    const minLength = min => value => (value && value.length < min ? `Deve ter ${min} caracteres ou mais` : undefined);
    const minLengthCEPDesc = min => value => (value && value.length < min ? `Deve ter ${min} caracteres` : undefined);
    const minLength2 = minLength(2);
    const minLengthCEP = minLengthCEPDesc(8);

    const { handleSubmit, readOnly, enderecoUDP } = this.props;
    const premiumForm = this.props.premiumLayout === true;

    let aneisAtivos = ['', 'hidden', 'hidden', 'hidden'],
      aneis = this.props.valores.aneis;
    for (let anel in aneis) {
      if (anel) {
        aneisAtivos[anel] = aneis[anel].ativo ? '' : 'hidden';
      }
    }
    const anelSelecionadoIndex = (this.props.valores.anel || 1) - 1;
    const anelSelecionado = this.props.valores.aneis[anelSelecionadoIndex] || {};
    const numeroFasesIniAtual = this.props.valores.numero_fases || anelSelecionado.numero_fases;
    const numeroFasesFimAtual = this.props.valores.numero_fases_fim || anelSelecionado.numero_fases_fim;

    const dadosParaRelatorio = () => {
      const v = this.props.valores || {};
      return {
        id: v.id,
        numero_controlador: v.numero_controlador,
        grupo_fisico_id: v.grupo_fisico_id,
        ip: v.ip,
        porta: v.porta,
        endereco: v.endereco,
        cruzamento: v.cruzamento,
      };
    };

    return (
      <form onSubmit={handleSubmit} className={premiumForm ? 'controlador-form-premium' : ''}>
        {/* <Field name='id' component={LabelAndInput} readOnly={true}
                    label='Código' cols='12' placeholder='Automático' /> */}
        <ProcessingOverlay
          show={this.state.showModal}
          message={
            this.state.messageModal ? (
              <>
                {this.state.messageModal}
                {this.state.processingDetail ? <small>{this.state.processingDetail}</small> : null}
              </>
            ) : (
              <>
                Aguarde, processando...
                <small>Operação em andamento no controlador.</small>
              </>
            )
          }
          tagline={this.state.processingTagline || 'Controlador'}
        />

        <ActionConfirmModal
          show={this.state.showCancelConfirm}
          title="Existem alterações não salvas"
          message="Deseja sair e perder as alterações?"
          confirmLabel="Sim, sair"
          cancelLabel="Não, continuar"
          destructive
          icon="exclamation-triangle"
          onConfirm={this.confirmarCancelar}
          onCancel={this.cancelarConfirmacaoCancelar}
        />

        <div className={premiumForm ? 'controlador-premium-container' : 'clearfix'}>
          <div className={premiumForm ? 'controlador-premium-card' : 'clearfix'}>
            {premiumForm && (
              <div className="controlador-premium-card-header">
                <div>
                  <h4>
                    <i className="fa fa-microchip" /> Identificação e localização
                  </h4>
                  <p>Dados principais, comunicação e posicionamento do controlador.</p>
                </div>
                {this.props.controladorId && (
                  <PermissaoUsuario tela="CadControlador" condicao={true}>
                    <ButtonTooltip
                      id="report-controlador-form"
                      type="button"
                      className=" controlador-premium-header-report"
                      icon="print"
                      data-title="Relatório PDF"
                      onClick={() => this.setState({ showReportModal: true })}
                    />
                  </PermissaoUsuario>
                )}
              </div>
            )}
            <div className={premiumForm ? 'controlador-premium-card-body' : 'clearfix'}>
              <div
                className={
                  premiumForm
                    ? 'nav-tabs-custom controlador-premium-tabs controlador-premium-ident-tabs'
                    : 'nav-tabs-custom controlador-ident-tabs'
                }
              >
                <ul className="nav nav-tabs">
                  <li className={this.state.showIdentTab === 'tabIdentDados' ? 'active' : ''}>
                    <span
                      className="button_tabs"
                      role="button"
                      tabIndex={0}
                      onClick={() => this.handleShowIdentTab('tabIdentDados')}
                    >
                      <i className="fa fa-id-card" /> Dados
                    </span>
                  </li>
                  <li className={this.state.showIdentTab === 'tabIdentMonitoramento' ? 'active' : ''}>
                    <span
                      className="button_tabs"
                      role="button"
                      tabIndex={0}
                      onClick={() => this.handleShowIdentTab('tabIdentMonitoramento')}
                    >
                      <i className="fa fa-shield-alt" /> Monitoramento
                    </span>
                  </li>
                </ul>

                <div className="tab-content">
                  <div
                    id="tabIdentDados"
                    className={`tab-pane ${this.state.showIdentTab === 'tabIdentDados' ? 'active' : ''}`}
                  >
                    <div className="box box-primary">
                      <div className="box-body">
                        <If condicao={readOnly}>
                          <Field
                            name="numero_controlador"
                            component={LabelAndInput}
                            readOnly={true}
                            label="N. Controlador*"
                            cols="12 6"
                            placeholder="Automático"
                          />
                        </If>

                        <If condicao={!readOnly}>
                          <SelectNumeroControlador
                            cols="12 6"
                            name="numero_controlador"
                            label="N. Controlador*"
                            validate={requiredSelect}
                          />
                        </If>

                        {/* <Field
                    name='numero_controlador'
                    component={LabelAndInput}
                    type='number'
                    // id="tempo_vermelho_min"
                    label='N. Controlador*'
                    cols='12'
                    placeholder='1 à 99'
                    validate={required}
                // readOnly={validaPermissaoReadOnly('CadControlador', 'tempo_minimo')}
                /> */}

                        <PermissaoUsuario tela="CadControlador" campo="cep" condicao={true}>
                          <Field
                            name="cep"
                            component={LabelAndInput}
                            label="CEP*"
                            cols="12 6"
                            maxLength={8}
                            placeholder="Informe só números"
                            onKeyDown={InputValidacao.validaSoNumeroInteiro}
                            onBlur={e => {
                              this.cepOnBlur(e);
                            }}
                            // props={{ onBlur: this.cepOnBlur }}
                            validate={[required, minLengthCEP]}
                          />
                          {this.state.cepErro && (
                            <div className="col-xs-12" style={{ marginTop: '-10px', marginBottom: '8px' }}>
                              <p style={{ color: 'red', margin: 0 }}>{this.state.cepErro}</p>
                            </div>
                          )}
                        </PermissaoUsuario>

                        <PermissaoUsuario tela="CadControlador" campo="cep" condicao={false}>
                          <Field name="cep" component={LabelAndInput} label="CEP*" cols="12 6" readOnly={true} />
                        </PermissaoUsuario>

                        <ConexaoUDPTeste
                          udp={enderecoUDP}
                          numCont={this.props.valores.numero_controlador}
                          controladorId={this.props.controladorId}
                          required={required}
                          readOnly={validaPermissaoReadOnly}
                          change={this.props.change}
                          onEquipamentoSincronizado={this.atualizarBaselineAposSincEquipamento}
                        />

                        <div className={premiumForm ? 'controlador-premium-section-divider' : 'clearfix'} />

                        <div className={premiumForm ? 'controlador-premium-location-grid' : 'clearfix'}>
                          {premiumForm ? (
                            <>
                              <div className="controlador-premium-related-group">
                                <div className="controlador-premium-related-title">
                                  <i className="fa fa-calendar-o" /> Horário de Verão
                                </div>
                                <Field
                                  name="data_inicio_verao"
                                  id="data_inicio_verao"
                                  component={LabelAndInput}
                                  type="date"
                                  label="Início Horário Verão"
                                  cols="12 6"
                                  placeholder="Informe a data"
                                  readOnly={validaPermissaoReadOnly('CadControlador', 'inicio_fim_horario_vereao')}
                                />

                                <Field
                                  name="data_fim_verao"
                                  id="data_fim_verao"
                                  component={LabelAndInput}
                                  type="date"
                                  label="Fim Horário Verão"
                                  cols="12 6"
                                  placeholder="Informe a data"
                                  readOnly={validaPermissaoReadOnly('CadControlador', 'inicio_fim_horario_vereao')}
                                />

                                <PermissaoUsuario
                                  tela="CadControlador"
                                  campo="inicio_fim_horario_vereao"
                                  condicao={true}
                                >
                                  <div className="col-xs-12 col-sm-6 form-group form-group-sm">
                                    <Button
                                      type="button"
                                      className="primary form-control"
                                      icon="upload"
                                      label="Enviar Horário de Verão"
                                      onClick={this.enviarHorarioVeraoControlador}
                                    />
                                  </div>
                                </PermissaoUsuario>

                                <PermissaoUsuario
                                  tela="CadControlador"
                                  campo="inicio_fim_horario_vereao"
                                  condicao={false}
                                >
                                  <div className="col-xs-12 col-sm-6 form-group form-group-sm">
                                    <Button
                                      type="button"
                                      className="primary form-control"
                                      icon="upload"
                                      label="Enviar Horário de Verão"
                                      disabled="disabled"
                                    />
                                  </div>
                                </PermissaoUsuario>
                              </div>

                              <div className="controlador-premium-related-group">
                                <div className="controlador-premium-related-title">
                                  <i className="fa fa-map-marker" /> Localização
                                </div>
                                <Field
                                  name="latitude"
                                  id="controador_latitude"
                                  component={LabelAndInput}
                                  readOnly={true}
                                  label="Latitude"
                                  cols="12 6"
                                  placeholder="Informe a latitude"
                                />

                                <Field
                                  name="longitude"
                                  id="controador_longitude"
                                  component={LabelAndInput}
                                  readOnly={true}
                                  label="Longitude"
                                  cols="12 6"
                                  placeholder="Informe a longitude"
                                />

                                <PermissaoUsuario tela="CadControlador" campo="adicionar_local_mapa" condicao={true}>
                                  <div className="col-xs-12 col-sm-6 form-group form-group-sm">
                                    <Button
                                      type="button"
                                      className="success form-control"
                                      icon="map-marked-alt"
                                      label="Adicionar localização ao Mapa"
                                      onClick={this.handleShow}
                                    />
                                  </div>
                                </PermissaoUsuario>

                                <PermissaoUsuario tela="CadControlador" campo="adicionar_local_mapa" condicao={false}>
                                  <div className="col-xs-12 col-sm-6 form-group form-group-sm">
                                    <Button
                                      type="button"
                                      className="success form-control"
                                      icon="map-marked-alt"
                                      label="Adicionar localização ao Mapa"
                                      disabled="disabled"
                                    />
                                  </div>
                                </PermissaoUsuario>
                              </div>
                            </>
                          ) : (
                            <>
                              <Field
                                name="data_inicio_verao"
                                id="data_inicio_verao"
                                component={LabelAndInput}
                                type="date"
                                label="Início Horário Verão"
                                cols="12 5"
                                placeholder="Informe a data"
                                readOnly={validaPermissaoReadOnly('CadControlador', 'inicio_fim_horario_vereao')}
                              />

                              <Field
                                name="data_fim_verao"
                                id="data_fim_verao"
                                component={LabelAndInput}
                                type="date"
                                label="Fim Horário Verão"
                                cols="12 5"
                                placeholder="Informe a data"
                                readOnly={validaPermissaoReadOnly('CadControlador', 'inicio_fim_horario_vereao')}
                              />

                              <PermissaoUsuario tela="CadControlador" campo="inicio_fim_horario_vereao" condicao={true}>
                                <div className="col-xs-12 col-sm-2 form-group form-group-sm">
                                  <div>
                                    <b>&nbsp;</b>
                                  </div>
                                  <Button
                                    type="button"
                                    className="primary form-control"
                                    icon="upload"
                                    label="Enviar Horário de Verão"
                                    onClick={this.enviarHorarioVeraoControlador}
                                  />
                                </div>
                              </PermissaoUsuario>

                              <PermissaoUsuario
                                tela="CadControlador"
                                campo="inicio_fim_horario_vereao"
                                condicao={false}
                              >
                                <div className="col-xs-12 col-sm-2 form-group form-group-sm">
                                  <div>
                                    <b>&nbsp;</b>
                                  </div>
                                  <Button
                                    type="button"
                                    className="primary form-control"
                                    icon="upload"
                                    label="Enviar Horário de Verão"
                                    disabled="disabled"
                                  />
                                </div>
                              </PermissaoUsuario>

                              <div className="clearfix" />

                              <Field
                                name="latitude"
                                id="controador_latitude"
                                component={LabelAndInput}
                                readOnly={true}
                                label="Latitude"
                                cols="12 5"
                                placeholder="Informe a latitude"
                              />

                              <Field
                                name="longitude"
                                id="controador_longitude"
                                component={LabelAndInput}
                                readOnly={true}
                                label="Longitude"
                                cols="12 5"
                                placeholder="Informe a longitude"
                              />

                              <PermissaoUsuario tela="CadControlador" campo="adicionar_local_mapa" condicao={true}>
                                <div className="col-xs-12 col-sm-2 form-group form-group-sm">
                                  <div>
                                    <b>&nbsp;</b>
                                  </div>
                                  {/* <If condicao={!this.props.controladorId}> */}
                                  <Button
                                    type="button"
                                    className="success form-control"
                                    icon="map-marked-alt"
                                    label="Adicionar localização ao Mapa"
                                    onClick={this.handleShow}
                                  />
                                  {/* </If>
                                    <If condicao={this.props.controladorId}>
                                        <Button type='button' className='success' icon='map-marked-alt' label='Adicionar localização ao Mapa' disabled="disabled" />
                                    </If> */}
                                </div>
                              </PermissaoUsuario>

                              <PermissaoUsuario tela="CadControlador" campo="adicionar_local_mapa" condicao={false}>
                                <div className="col-xs-12 col-sm-2 form-group form-group-sm">
                                  <div>
                                    <b>&nbsp;</b>
                                  </div>
                                  <Button
                                    type="button"
                                    className="success form-control"
                                    icon="map-marked-alt"
                                    label="Adicionar localização ao Mapa"
                                    disabled="disabled"
                                  />
                                </div>
                              </PermissaoUsuario>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    id="tabIdentMonitoramento"
                    className={`tab-pane ${this.state.showIdentTab === 'tabIdentMonitoramento' ? 'active' : ''}`}
                  >
                    <div className="box box-primary">
                      <div className="box-body">{this.renderMonitoramentoFields()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="modal-mapa">
          <Modal.Header className="modal-header" closeButton>
            <Modal.Title>Mapa de Controlador</Modal.Title>
          </Modal.Header>
          <Modal.Body className="modal-body">
            {this.state.htmlMapaCont}

            {/* <MapaControlador
                            data-contId={controladorId}
                            data-latitude={latitude}
                            data-longitude={longitude}
                            latitude={this.state.cepLat}
                            longitude={this.state.cepLng}
                        /> */}
          </Modal.Body>
          <Modal.Footer className="modal-header">
            <Button type="button" className="primary" icon="check" label="OK" onClick={this.clickOk} />
          </Modal.Footer>
        </Modal>

        <div className={premiumForm ? 'nav-tabs-custom controlador-premium-tabs' : 'nav-tabs-custom'}>
          <ul className="nav nav-tabs">
            <li className={this.state.showTab === 'tabAnel' ? 'active' : ''}>
              <span
                className={'button_tabs'}
                data-toggle="tab"
                onClick={() => this.handleShowTab('tabAnel')}
                data-target="tabAnel"
              >
                <i className={`fa fa-cog`} /> Configurações de Anéis
              </span>
            </li>
            <li className={this.state.showTab === 'tabLaco' ? 'active' : ''}>
              <span
                className={'button_tabs'}
                data-toggle="tab"
                onClick={() => this.handleShowTab('tabLaco')}
                data-target="tabLaco"
              >
                <i className={`fa fa-pencil-alt`} /> Descrição dos Laços
              </span>
            </li>
            <li className={this.state.showTab === 'tabCroqui' ? 'active' : ''}>
              <span
                className={'button_tabs'}
                data-toggle="tab"
                onClick={() => this.handleShowTab('tabCroqui')}
                data-target="tabCroqui"
              >
                <i className={`fa fa-cog`} /> Croqui
              </span>
            </li>
            {this.state.showTab === 'tabAnel' && (
              <li className="controlador-premium-read-plan-tab-action">
                <PermissaoUsuario tela="CadControlador" campo="ler_fase_tempo" condicao={true}>
                  <Button
                    type="button"
                    className="primary"
                    icon="download"
                    label="Ler Plano de Segurança"
                    onClick={this.lerFaseTempoControlador}
                  />
                </PermissaoUsuario>
                <PermissaoUsuario tela="CadControlador" campo="ler_fase_tempo" condicao={false}>
                  <Button
                    type="button"
                    className="primary"
                    icon="download"
                    label="Ler Plano de Segurança"
                    disabled="disabled"
                  />
                </PermissaoUsuario>
              </li>
            )}
          </ul>
          <div className="tab-content">
            <div id="tabAnel" className={`tab-pane ${this.state.showTab === 'tabAnel' ? 'active' : ''} `}>
              <div className="box box-primary">
                <div className="box-body">
                  <Field
                    name="anel"
                    component={LabelAndSelectForm}
                    label="Anel"
                    cols="12 4"
                    onChange={event => {
                      // O anel atual tem que receber a fase do state para funcionar a gravação de latitudo e logitudo
                      this.syncConflitosAnelCorrenteDoForm();
                      this.props.valores.aneis[this.props.valores.anel - 1].fases = this.state.fases;
                      this.anelChange(event.target.value - 1);
                    }}
                  >
                    <option value="1">1</option>
                    <option hidden={aneisAtivos[1]} value="2">
                      2
                    </option>
                    <option hidden={aneisAtivos[2]} value="3">
                      3
                    </option>
                    <option hidden={aneisAtivos[3]} value="4">
                      4
                    </option>
                  </Field>

                  <Field
                    name="endereco"
                    component={LabelAndInput}
                    label="Endereço*"
                    cols="12 4"
                    placeholder="Informe o endereço"
                    validate={[required, minLength2]}
                    readOnly={validaPermissaoReadOnly('CadControlador', 'endereco')}
                    onBlur={e => {
                      this.props.valores.aneis[this.props.valores.anel - 1].endereco = e.target.value;
                    }}
                  />

                  <Field
                    name="cruzamento"
                    component={LabelAndInput}
                    label="Cruzamento*"
                    cols="12 4"
                    placeholder="Informe a descrição do cruzamento"
                    validate={[required, minLength2]}
                    readOnly={validaPermissaoReadOnly('CadControlador', 'cruzamento')}
                    onBlur={e => {
                      this.props.valores.aneis[this.props.valores.anel - 1].cruzamento = e.target.value;
                    }}
                  />

                  <PermissaoUsuario tela="CadControlador" campo="numero_fases" condicao={true}>
                    <SelectFaseControlador
                      label="Fase Inicial"
                      name="numero_fases"
                      faseIni={1}
                      disabled="disabled"
                      cols="12 4"
                    />
                  </PermissaoUsuario>

                  <PermissaoUsuario tela="CadControlador" campo="numero_fases" condicao={false}>
                    <SelectFaseControlador
                      label="Fase Inicial"
                      name="numero_fases"
                      faseIni={1}
                      disabled="disabled"
                      cols="12 4"
                    />
                  </PermissaoUsuario>

                  <SelectFaseControlador
                    label="Fase Final"
                    name="numero_fases_fim"
                    // faseIni={this.props.valores.aneis[this.props.valores.anel - 1].numero_fases}
                    faseIni={this.props.valores.numero_fases}
                    disabled="disabled"
                    cols="12 4"
                    onChange={() => {
                      this.geraGridFase(this.props.valores.anel - 1);
                    }}
                  />
                </div>
              </div>

              <div className={premiumForm ? 'controlador-premium-fases-card' : 'row'}>
                <div
                  className={premiumForm ? 'controlador-premium-fases-conflicts' : 'col-md-12'}
                  style={premiumForm ? null : { paddingBottom: '20px' }}
                >
                  <FaseConflitoControlador
                    // numeroFases={numeroFases}
                    key={`fase-conflito-${this.props.valores.anel}-${numeroFasesIniAtual}-${numeroFasesFimAtual}`}
                    numeroFasesIni={numeroFasesIniAtual}
                    numeroFases={numeroFasesFimAtual}
                    disabled={true}
                    // disabled={validaPermissaoDisabled('CadControlador', 'fase_conflitante')}
                    atualizarDoAnel={true}
                    anelSelecionado={anelSelecionadoIndex}
                    aneis={this.props.valores.aneis}
                  />
                </div>
                <div className={premiumForm ? 'controlador-premium-fases-table' : 'box-footer'}>{this.state.html}</div>
              </div>
            </div>
            <div id="tabLaco" className={`tab-pane ${this.state.showTab === 'tabLaco' ? 'active' : ''} `}>
              <div className="box box-primary">
                <div className="box-body">{this.renderFieldLaco()}</div>
              </div>
            </div>
            <div id="tabCroqui" className={`tab-pane ${this.state.showTab === 'tabCroqui' ? 'active' : ''} `}>
              <div className="box box-primary">
                <div className="box-body">
                  <div>
                    <Field name="croqui_file_id" id="croqui_file_id" component={this.renderFileInput} />
                    {this.state.showCroquiDeleteWarning && (
                      <p style={{ color: 'red' }}>Arquivo do croqui será deletado!</p>
                    )}
                    {this.state.croquiFileErrorMessage && (
                      <p style={{ color: 'red' }}>{this.state.croquiFileErrorMessage}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={premiumForm ? 'box-footer controlador-premium-footer' : 'box-footer'}>
          {/* <Button type='submit' className={this.props.submitClass} icon='check' label={this.props.submitLabel} /> */}
          {/* <Button type='button' className='danger' icon='check' label='Salvar - TESTE'
                        onClick={() => {
                            this.props.valores.fases = this.state.fases;
                            if (!this.verificaAlteracao()) {
                                this.props.handleSubmit();
                            } else {

                                this.setState({ showModal: true }); // da show no modal de aguarde
                                this.props.handleSubmit();
                            }
                        }} /> */}
          {/* <Button type='button' className='primary' icon='check' label='Salvar/Enviar Controlador' onClick={this.salvarControlador} /> */}
          <Button type="button" className="primary" icon="check" label="Salvar" onClick={this.salvarControlador} />
          {/* <Button type='button' className='danger' icon='image' labal='salvar imagem'
                        onClick={() => {
                            // encodeSvg(this.componentRef);

                            // console.log('formControlador',document.querySelector("#formControlador"));

                            // console.log('this.componentRef',this.componentRef.current);

                            html2canvas(this.componentRef.current)
                                .then((canvas) => {
                                    console.log(canvas);
                                    canvas.style.display = 'none';
                                    let image = canvas.toDataURL("png");

                                    // document.querySelector("#testeimg").setAttribute('src', image);

                                    console.log('image',image);
                                    // var a = document.createElement("a");
                                    // a.setAttribute('download', 'myImage.png');
                                    // a.setAttribute('href', image);
                                    // a.click();
                                });

                            // exportComponentAsJPEG(this.componentRef, { fileName: 'controlador' });
                            // exportComponentAsPNG(this.componentRef, { fileName: 'controlador' });
                        }}
                    /> */}

          <Button type="button" className="default" icon="close" label="Cancelar" onClick={this.handleCancelar} />
          <img id="testeimg" src="" alt="" />
        </div>

        {this.state.showReportModal && (
          <ControladorReportModal
            controlador={dadosParaRelatorio()}
            onClose={() => this.setState({ showReportModal: false })}
          />
        )}
      </form>
    );
  }
}

// const mapStateToProps = state => ({ list: state.controladorCad.list })

// destroyOnUnmount: false  permite utilizar o mesmo componente form para cadastrar e para alterar, se tirar essa propriedade o sistema cria um
// form limpo para o update
ControladorForm = reduxForm({ form: 'controladorForm', destroyOnUnmount: false })(ControladorForm);

// aula 151 - utilizado para pegar o dado do form e jogar dentro do objeto props, depois ele é extraido no render()
const selector = formValueSelector('controladorForm');
const mapStateToProps = state => ({
  enderecoUDP: {
    ip: selector(state, 'ip'),
    porta: selector(state, 'porta'),
  },
  numeroFases: selector(state, 'numero_fases'),
  latitude: selector(state, 'latitude'),
  longitude: selector(state, 'longitude'),
  controladorId: selector(state, 'id'),
  contAtivo: selector(state, 'ativo'),
  grupo_fisico: selector(state, 'grupo_fisico_id'),
  cep: selector(state, 'cep'),

  valores: getFormValues('controladorForm')(state),

  croqui_file_id: selector(state, 'croqui_file_id'),
  croqui_file_data: selector(state, 'croqui_file'),
  croqui_file_name: selector(state, 'croqui_file_name'),

  config: state.auth.config,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      init,
      getList,
      getFaseList,
      getFaseListNovo,
      create,
      enviarTemposControlador,
      lerQuantidadeAneis,
      lerTemposControlador,
      lerDadosFasesControlador,
      enviarHorarioVeraoControlador,
      getLocalCEP,
      getImageCroquiById,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ControladorForm);
